import { Vector2 } from '../../../odie';
import { app } from '../../app';

import { CollideEvent, CollideId } from '../../defs/collide';
import {
  despawnBlockEntity,
  MiniFuguBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { mapGetPan } from '../../util/mapTools';
import { InvalidEffect } from '../effects/InvalidEffect';
import { SplashEffect } from '../effects/SplashEffect';
import { CollideHandler, ICollision } from './ICollision';

/*
    Mini fugu block collision resolver
*/
export class MiniFuguCollision implements ICollision {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _entity: MiniFuguBlockEntity;
  // map
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this._resolveTap,
    block: this._resolveBlock,
    attack: this._resolveAttack,
  };

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, entity: MiniFuguBlockEntity) {
    this._scene = scene;
    this._entity = entity;
  }

  // impl
  //-------------------------------------------------------------------------
  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  // private: resolvers
  //-------------------------------------------------------------------------
  private async _resolveTap() {
    // invalid effect
    await new InvalidEffect(this._entity).execute();
    return false;
  }

  private async _resolveBlock() {
    this._attack();
    return true;
  }

  private async _resolveAttack() {
    this._attack();
    return true;
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _attack() {
    app.sound.play('puzzle-fugu-destroy', {
      pan: mapGetPan(this._entity.c.position.mapPosition),
    });

    const position = this._entity.c.position.mapPosition;

    this._breakBlock(position);
  }

  private async _breakBlock(position: Vector2) {
    // despawn entity
    despawnBlockEntity(this._scene, this._entity);

    // execute splash effect
    await new SplashEffect(this._scene, {
      position,
      scale: [
        { x: 0.6, y: 0.6 },
        { x: 1.2, y: 1.2 },
      ],
    }).execute();
  }
}
